import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LanguageService } from 'src/app/services/account/language.service';
import { SettingsService, Unit } from 'src/app/services/account/settings.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Route } from 'src/app/models/route';
import { TurnValueIntegerThousandsPipe } from 'src/app/pipes/turn-value-integer-thousands.pipe';
import { ValueIntegerPipe } from 'src/app/pipes/value-integer.pipe';

interface DistanceDisplay {
  value: number;
  unit: 'km' | 'm' | 'mi' | 'yard';
  isThousands: boolean;
}

@Component({
  standalone: true,
  selector: 'app-track-information',
  templateUrl: './track-information.component.html',
  styleUrls: ['./track-information.component.scss'],
  imports: [TurnValueIntegerThousandsPipe, ValueIntegerPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrackInformationComponent {
  @Input() routeData: Route | null = null;
  @Input() failedPlan: boolean = false;
  @Input() noRoute: boolean = false;
  @Input() loadingMap: string = '';

  constructor(
    public languageService: LanguageService,
    public utilsService: UtilsService,
    public settingsService: SettingsService
  ) { }

  public get hasData(): boolean {
    return !this.failedPlan && !this.noRoute && !this.loadingMap;
  }

  public get distanceDisplay(): DistanceDisplay {
    if (this.routeData) {
      const distance = this.routeData.RouteInfo.Distance;
      const isMetric = this.settingsService.getUnit().Distance == Unit.Metric;

      if (isMetric) {
        return distance >= 1000
          ? { value: distance / 1000, unit: 'km', isThousands: true }
          : { value: distance, unit: 'm', isThousands: false };
      }

      return this.utilsService.mToYard(distance) >= 1760
        ? { value: distance * 0.000621371192, unit: 'mi', isThousands: true }
        : { value: distance * 1.0936133, unit: 'yard', isThousands: false };
    }
    else{
      return { value: 0, unit: 'm', isThousands: false };
    }
  }
}
